/** 用户可见文案：剧本临时角色画像（由 C 列台词 AI 分析生成，非气氛员管理中的成员画像） */
export const SCRIPT_ROLE_PERSONA_TERM = "剧本画像";

export function formatMissingScriptRolePersonaError(tempRoleId: string): string {
  return (
    `气氛员${tempRoleId} 缺少${SCRIPT_ROLE_PERSONA_TERM}：` +
    "该角色的 AI 人设分析尚未完成、失败，或未成功写入缓存。" +
    `${SCRIPT_ROLE_PERSONA_TERM}根据该角色在剧本中的台词生成，与「气氛员管理」里的成员画像不是同一回事。` +
    "请先完成画像分析，或对失败项重试后再匹配。"
  );
}

export function formatScriptRolePersonaCacheRequiredError(): string {
  return (
    `分配缓存不存在或未包含${SCRIPT_ROLE_PERSONA_TERM}：` +
    "请先读取飞书表格，完成画像分析后再开始匹配。"
  );
}

export function formatCandidateExpansionExhaustedError(tempRoleId: string): string {
  return (
    `气氛员${tempRoleId} 无法继续补充匹配候选：` +
    "分组内可用的真实气氛员已全部进入该角色的 Top 候选，或已被出场次数、晒单互斥（仅晒单角色之间）等规则排除。" +
    "请查看阻塞诊断中的候选池统计和拒绝原因。"
  );
}

export function formatScriptRoleMatchFailureError(
  tempRoleId: string,
  detail: string
): string {
  return `气氛员${tempRoleId} 匹配失败：${detail}`;
}
